(ns common.schema.entities.webentry
  (:require
   [common.schema.assets :as assets]
   [common.schema.schema-utils :as su]
   [common.schema.option-filters :as option-filters]
   [common.schema.entity-type-names :as entity-type-names]))

(def schema
  [[:webentry/apikey
    {:field/data-type             :data.type/text-simple
     :field/not-clearable?        true
     :field/default-visibility    {:editor :editor.type/text-simple
                                   :grid   :editor.type/text-simple
                                   :filter :filter.type/text
                                   :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/system}
     :field/translations          {:en "Webentry form ID"}}]
   [:webentry/type
    {:field/data-type             :data.type/keyword
     :field/not-clearable?        true
     :field/default-visibility    {:editor :editor.type/none
                                   :grid   :editor.type/none
                                   :filter :filter.type/none
                                   :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/user
                                   :access/write :role/system}
     :field/translations          {:en "Webentry form type"}}]
   [:webentry/display-name
    {:field/data-type             :data.type/text-simple
     :field/name-attribute        :webentry/display-name
     :field/mandatory             :mandatory/always
     :field/system-required?      true
     :field/system-semantics      su/user-provided-system-required-field-semantics
     :field/not-clearable?        true
     :field/lower-case-str?       true
     :field/default-visibility    {:editor :editor.type/text-simple
                                   :grid   :editor.type/text-simple
                                   :filter :filter.type/text
                                   :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :field/translations          {:en "Webentry name"}}]
   [:webentry/background-image
    {:field/data-type          :data.type/text-url
     :field/default-visibility {:editor :editor.type/image
                                :grid   :editor.type/text-simple
                                :filter :filter.type/text
                                :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :field/translations       {:en "Webentry background image"}}]
   [:webentry/handler-account
    {:field/data-type          :data.type/ref-single
     :value-type               :entity
     :field/entity-types       [:entity.type/account]
     :field/not-clearable?     true
     :field/default-visibility {:editor :editor.type/select
                                :grid   :editor.type/select
                                :filter :filter.type/select
                                :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/user
                                   :access/write :role/admin}
     :field/translations       {:en "Webentry handler"}
     :field/option-filter-fn   option-filters/active-users
     :field/os-filter-terms-fn    (fn [{:keys [] :as args}]
                                    {"extras.active-user" true})}]
   [:webentry/default-pipeline
    {:field/data-type          :data.type/ref-single
     :value-type               :entity
     :field/entity-types       [:entity.type/pipeline]
     :field/not-clearable?     true
     :field/default-visibility {:editor :editor.type/select
                                :grid   :editor.type/select
                                :filter :filter.type/select
                                :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/user
                                   :access/write :role/admin}
     :field/translations       {:en "Webentry default pipeline"}}]
   [:webentry/heading
    {:field/data-type          :data.type/text-simple
     :field/default-visibility {:editor :editor.type/text-simple
                                :grid   :editor.type/text-simple
                                :filter :filter.type/text
                                :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :field/translations       {:en "Webentry header"}}]
   [:webentry/heading-color
    {:field/data-type          :data.type/text-simple
     :field/default-visibility {:editor :editor.type/text-simple
                                :grid   :editor.type/text-simple
                                :filter :filter.type/text
                                :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :field/translations       {:en "Webentry header color"}}]
   [:webentry/heading-text
    {:field/data-type          :data.type/text-richtext
     :field/default-visibility {:editor :editor.type/wysiwyg
                                :grid   :editor.type/wysiwyg
                                :filter :filter.type/text
                                :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :field/translations       {:en "Webentry heading text"}}]
   [:webentry/logo
    {:field/data-type          :data.type/text-url
     :field/default-visibility {:editor :editor.type/image
                                :grid   :editor.type/text-simple
                                :filter :filter.type/text
                                :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :field/translations       {:en "Webentry logo"}}]
   [:webentry/position
    {:field/data-type :data.type/keyword
     :field/not-clearable? true
     :field/default-visibility {:editor :editor.type/select
                                :grid   :editor.type/select
                                :filter :filter.type/select
                                :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :options [{:key   :position/left
                :label "Left"}
               {:key   :position/center
                :label "Center"}
               {:key   :position/right
                :label "Right"}]
     :field/translations {:en "Webentry form position"}}]
   [:webentry/thank-you-text
    {:field/data-type          :data.type/text-simple
     :field/default-visibility {:editor :editor.type/text-simple
                                :grid   :editor.type/text-simple
                                :filter :filter.type/text
                                :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :field/translations       {:en "Webentry thank you text"}}]
   [:webentry/thank-you-title
    {:field/data-type          :data.type/text-simple
     :field/default-visibility {:editor :editor.type/text-simple
                                :grid   :editor.type/text-simple
                                :filter :filter.type/text
                                :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :field/translations       {:en "Webentry thank you header"}}]
   [:webentry/privacy-policy
    {:field/data-type          :data.type/text-url
     :field/default-visibility {:editor :editor.type/url
                                :grid   :editor.type/url
                                :filter :filter.type/text
                                :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :field/translations       {:en "Company privacy policy"}}]
   [:webentry/privacy-statement
    {:field/data-type             :data.type/text-multiline
     :field/default-visibility    {:editor :editor.type/textarea
                                   :grid   :editor.type/text-simple
                                   :filter :filter.type/text
                                   :field-visibility :in-use-disabled}
     :field/not-clearable?        true
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :field/translations          {:en "Privacy statement"}}]
   [:webentry/redirect-to
    {:field/data-type          :data.type/text-url
     :field/default-visibility {:editor :editor.type/url
                                :grid   :editor.type/url
                                :filter :filter.type/text
                                :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :field/translations       {:en "Direct visitors to this URL after webentry submission"}}]
   [:webentry/embed
    {:field/data-type             :data.type/boolean
     :field/not-clearable?        true
     :field/default-visibility    {:editor :editor.type/toggle
                                   :grid   :editor.type/toggle
                                   :filter :filter.type/boolean
                                   :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/user
                                   :access/write :role/admin}
     :field/translations          {:en "Webentry attachements"}}]
   [:webentry/custom-privacy-policy
    {:field/data-type             :data.type/boolean
     :field/not-clearable?        true
     :field/default-visibility    {:editor :editor.type/toggle
                                   :grid   :editor.type/toggle
                                   :filter :filter.type/boolean
                                   :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/user
                                   :access/write :role/admin}
     :field/translations          {:en "Custom privacy policy"}}]
   [:webentry/show-your-message
    {:field/data-type             :data.type/boolean
     :field/not-clearable?        true
     :field/default-visibility    {:editor :editor.type/toggle
                                   :grid   :editor.type/toggle
                                   :filter :filter.type/boolean
                                   :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/user
                                   :access/write :role/admin}
     :field/translations          {:en "Show \"Your message to us\" input area"}}]
   [:webentry/asset-type
    {:field/data-type :data.type/keyword
     ;;:field/default-ord        25
     :value-type :keyword
     :options (->> assets/target-asset-type-mappings
                   (map (fn [[et asset-types]]
                          asset-types))
                   (flatten)
                   (distinct)
                   (remove nil?)
                   (map (fn [at]
                          {:key   at
                           :label (->> entity-type-names/entities
                                       at
                                       :field/translations
                                       :en)}))
                   (vec))
     ;; TODO: if webentry forms are linked to specific pipeline in the future this must reflect the change
     :field/option-filter-fn (partial option-filters/asset-types (constantly (:entity.type/oppo assets/target-asset-type-mappings)))
     :field/default-visibility {:editor :editor.type/none
                                :grid   :editor.type/none
                                :filter :filter.type/text
                                :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/guest-buy-side
                                   :access/write :role/admin}
     ;;:disabled?                true
     :field/not-clearable? true
     ;;:field/not-importable?    true
     :field/translations {:en "Asset type"}
     ;;:field/label-icon         :fa-lock
     ;;:field/label-icon-tooltip (loc/tr :multiple-assets-tooltip)
     }]

   [:webentry/attachments
    {:field/data-type             :data.type/boolean
     :field/not-clearable?        true
     :field/default-visibility    {:editor :editor.type/toggle
                                   :grid   :editor.type/toggle
                                   :filter :filter.type/boolean
                                   :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :field/translations          {:en "Webentry attachements"}}]

   [:webentry/n-attachments-config
    {:field/data-type             :data.type/text-edn
     :field/not-clearable?        true
     :field/default-visibility    {:editor :editor.type/none
                                   :grid   :editor.type/none
                                   :filter :filter.type/none
                                   :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :field/translations          {:en "N attachments config"}}]

   [:webentry/checks-config
    {:field/data-type             :data.type/text-edn
     :field/not-clearable?        true
     :field/default-visibility    {:editor :editor.type/none
                                   :grid   :editor.type/none
                                   :filter :filter.type/none
                                   :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :field/translations          {:en "Checks config"}}]

   [:webentry/document-config
    {:field/data-type :data.type/keyword
     :value-type :keyword
     :field/not-clearable? true
     :field/default-visibility {:editor :editor.type/select
                                :grid   :editor.type/select
                                :filter :filter.type/select
                                :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :options [{:key   :webentry.documents/none
                :label "Can not send files"}
               {:key   :webentry.documents/pdf
                :label "Can send only pdf"}
               {:key   :webentry.documents/any
                :label "Can send any file type"}]
     :field/translations {:en "Allow visitors to send documents using this webform"}}]

   [:webentry/field-settings
    {:field/data-type             :data.type/text-edn
     :field/not-clearable?        true
     :field/default-visibility    {:editor :editor.type/none
                                   :grid   :editor.type/none
                                   :filter :filter.type/none
                                   :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :field/translations          {:en "Webentry selected fields"}}]
   [:webentry/field-descriptions
    {:field/data-type             :data.type/text-edn
     :field/not-clearable?        true
     :field/default-visibility    {:editor :editor.type/none
                                   :grid   :editor.type/none
                                   :filter :filter.type/none
                                   :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :field/translations          {:en "Webentry field descriptions"}}]
   [:webentry/colors
    {:field/data-type             :data.type/text-edn
     :field/not-clearable?        true
     :field/default-visibility    {:editor :editor.type/none
                                   :grid   :editor.type/none
                                   :filter :filter.type/none
                                   :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/system}
     :field/translations          {:en "Webentry color settings"}}]

   (first (su/text-edn-field :webentry/field-config "Field config" {:authorization su/access-admin-ssg
                                                                    :default-field-visibility :in-use-disabled}))

   [:webentry/configs
    {:field/data-type             :data.type/ref-multi
     :field/not-clearable?        true
     :field/default-visibility    {:editor :editor.type/none
                                   :grid   :editor.type/none
                                   :filter :filter.type/none
                                   :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/system}
     :field/translations          {:en "Webentry Configs"}}]
   [:webentry/email-opt-in
    {:field/data-type             :data.type/boolean
     :field/not-clearable?        true
     :field/default-visibility    {:editor :editor.type/toggle
                                   :grid   :editor.type/toggle
                                   :filter :filter.type/boolean
                                   :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/user
                                   :access/write :role/admin}
     :field/translations          {:en "Webentry email opt-in"}}]
   [:webentry/email-opt-in-title
    {:field/data-type          :data.type/text-simple
     :field/default-visibility {:editor :editor.type/text-simple
                                :grid   :editor.type/text-simple
                                :filter :filter.type/text
                                :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :field/translations       {:en "Webentry email opt-in title"}}]
   [:webentry/language
    {:field/data-type             :data.type/keyword
     :field/not-clearable?        true
     :field/default-visibility    {:editor :editor.type/none
                                   :grid   :editor.type/none
                                   :filter :filter.type/none
                                   :field-visibility :in-use-disabled}
     :field/default-authorization {:access/read  :role/none
                                   :access/write :role/admin}
     :field/translations          {:en "Webentry language"}}]])
